import React, { useState } from "react";
import NumberFormat from "react-number-format";

import { Button, Stack, TextField, Typography } from "@mui/material";
import { useReportsQueriesSelector } from "store";
import { ReportCashflowAum } from "store/types";

import { currencySign } from "../../../../constants";

interface IProps {
  onClose: () => void;
  aumData: ReportCashflowAum | null;
  updateAumSettings: (totalAum: number | null) => void;
}

export const PopoverContent: React.FC<IProps> = ({ onClose, updateAumSettings, aumData }) => {
  const [totalValue, setTotalValue] = useState<number>(aumData?.total_aum || 0);
  const { currency } = useReportsQueriesSelector();
  const currencySymbol = currencySign[currency] || "";

  return (
    <Stack sx={{ padding: "20px", width: "370px" }} gap="20px">
      <Typography sx={{ fontSize: "18px", fontWeight: 400 }}>AUM configuration</Typography>
      <NumberFormat
        fullWidth
        label="Total AUM"
        customInput={TextField}
        allowNegative={false}
        isNumericString
        prefix={currencySymbol}
        thousandSeparator
        decimalScale={2}
        value={totalValue}
        onValueChange={(values) => setTotalValue(Number(values.value))}
      />
      <Stack direction="row" justifyContent="flex-end" gap="10px">
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          disabled={totalValue === 0}
          onClick={() => {
            updateAumSettings(totalValue);
          }}
          variant="contained"
        >
          Apply
        </Button>
      </Stack>
    </Stack>
  );
};
